<template>
  <svg
    :class="svgClass"
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    v-if="show"
  >
    <defs>
      <pattern id="dotsPattern" patternUnits="userSpaceOnUse" width="4" height="4">
        <rect width="4" height="4" :fill="backgroundColor" />
        <circle cx="2" cy="2" r="1" :fill="dotColor" :opacity="dotOpacity" />
      </pattern>
    </defs>
    <rect x="0" y="0" width="20" height="20" fill="url(#dotsPattern)" />
  </svg>
</template>

<script>
export default {
  name: "SoldPendingStatus",
  props: {
    svgClass: { type: String, default: "" },
    show: { type: Boolean, default: true },
    backgroundColor: { type: String, default: "#A86B5A" },
    dotColor: { type: String, default: "#6E2F1F" },
    dotOpacity: { type: Number, default: 0.9 }
  }
};
</script>
